import { policyType } from '@ourbranch/lookups';

export const SOMETHING_ELSE = 'somethingElse';

const startsWithAny = (prefixes) => (path) =>
  prefixes.some((prefix) => path === prefix || path.startsWith(`${prefix}.`));

// "What's changing?" in the Make a change drawer, per policy type. `sections` names what the drawer shows (see
// HomePolicy / AutoPolicy `show`). `covers` says which form and preview-diff paths ("homeCoverage.deductibleAllOther",
// "cars.0.deductibleCollision") belong to the choice: validation errors elsewhere are listed in the drawer, and a
// preview that changes anything else gets a warning. Other policy types have only "Something else", the full form.
export const CHANGE_TYPES = {
  [policyType.Home]: [
    {
      value: 'deductible',
      label: 'Deductible',
      sections: ['homeCoverage'],
      covers: (path) => /^homeCoverage\.deductible/.test(path)
    },
    {
      value: 'personalLiability',
      label: 'Personal liability',
      sections: ['homeCoverage'],
      covers: startsWithAny(['homeCoverage.coverageX'])
    },
    {
      value: 'mortgage',
      label: 'Mortgage company',
      sections: ['mortgage'],
      covers: startsWithAny(['home.mortgageDetails', 'primaryMortgageDetail'])
    },
    {
      value: 'people',
      label: 'Add or remove a person',
      sections: ['people'],
      covers: startsWithAny(['people', 'fcraDisclaimer'])
    }
  ],
  [policyType.Auto]: [
    {
      value: 'deductible',
      label: 'Deductible',
      sections: ['carDeductible'],
      covers: (path) => /^cars\.\d+\.deductible/.test(path)
    },
    {
      value: 'liability',
      label: 'Liability limits',
      sections: ['autoCoverage'],
      covers: startsWithAny(['autoCoverage'])
    },
    {
      value: 'drivers',
      label: 'Add or remove a driver',
      sections: ['drivers'],
      // Drivers are assigned to cars, and Michigan PIP counts every resident.
      covers: (path) =>
        startsWithAny(['drivers', 'nonDrivers', 'removedDrivers', 'fcraDisclaimer', 'auto.pip'])(path) ||
        /^cars\.\d+\.assignedDriver/.test(path)
    },
    {
      value: 'cars',
      label: 'Add or remove a car',
      sections: ['cars'],
      // A new car's lienholder rides along as a policy-level additional party.
      covers: startsWithAny(['cars', 'additionalParties'])
    }
  ]
};

const SOMETHING_ELSE_TYPE = { value: SOMETHING_ELSE, label: 'Something else', sections: null, covers: () => true };

export const getChangeTypes = (policyTypeCode) => [...(CHANGE_TYPES[policyTypeCode] ?? []), SOMETHING_ELSE_TYPE];

export const getChangeType = (policyTypeCode, value) =>
  getChangeTypes(policyTypeCode).find((changeType) => changeType.value === value) ?? null;
